import React from "react";
import { IIcons } from "./icons";

const RightArrowFilledIcon = ({ fillColor, width = "16", height = "19", fill = "#f2f2f2" }: IIcons.IconProps) => (
  <svg width={width} height={height} viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 9.5L0.249999 18.5933L0.25 0.406733L16 9.5Z" fill={fill} className={fillColor} />
  </svg>
);
export default RightArrowFilledIcon;
